// src/services/pitchTypesService.js

import { api } from "./api";

// Trae todos los tipos
export const getPitchTypes = async () => {
  try {
    const response = await api.get("/api/pitch-types/");
    return response.data;
  } catch (error) {
    console.error("Error fetching pitch types:", error.response || error.message || error);
    return [];
  }
};

// Trae un tipo específico por ID
export const getPitchTypeById = async (id) => {
  try {
    const response = await api.get(`/api/pitch-types/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching pitch type with ID ${id}:`, error.response || error.message || error);
    return null;
  }
};
